export const getPayrollSourceTypeKey = (sourceType) => {
  const value = typeof sourceType === 'string' ? sourceType : Number(sourceType);
  if (value === 2 || value === 'MembershipMonthlyShare') return 'membershipMonthlyShare';
  if (value === 3 || value === 'MembershipPeriodUsageShare') return 'membershipPeriodUsageShare';
  if (value === 4 || value === 'AppointmentAdditionalCost') return 'appointmentAdditionalCost';
  if (value === 5 || value === 'ProductSale') return 'productSale';
  return 'appointmentService';
};

export const isAppointmentAdditionalCostSource = (sourceType) => {
  const value = typeof sourceType === 'string' ? sourceType : Number(sourceType);
  return value === 4 || value === 'AppointmentAdditionalCost';
};
